import { call, put } from "redux-saga/effects";
import * as action_type from "../../../../Store/Constant";
import {
  AUTH_MULTYPART_HEADERS,
  API_URL,
  AUTH_HEADERS,
  HEADERS,
  LIMIT_DATA,
} from "../../../../Axios/axiosData";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

// export function* getCreateInviteResource(payload) {
//   let data = { response: false, backend_data: null };
//   let formValue = payload?.payload;

//   yield axios
//     .post(API_URL + "accounts/invite-user/create/", formValue, AUTH_HEADERS())
//     .then((resp) => {
//       data.response = true;
//       data.backend_data = resp.data;

//       if (payload?.data) {
//         payload?.data();
//       }

//       toast.success(resp?.data?.message);
//     })
//     .catch((error) => {
//       if (error?.response?.data?.email) {
//         toast.error(`${"Email"} : ${error?.response?.data?.email[0]}`);
//       }

//       if (error?.response?.data?.user) {
//         toast.error(`${"User"} : ${error?.response?.data?.user}`);
//       }
//     });

//   yield put({ type: action_type.GET_NAVIGATE, data });
// }
export function* getCreateInviteResource(action) {
  let data = { response: false, backend_data: null };
  let formValue = action?.payload;

  try {
    // ✅ WAIT for headers
    const headers = yield call(AUTH_HEADERS);

    const resp = yield call(
      axios.post,
      API_URL + "accounts/invite-user/create/",
      formValue,
      headers
    );

    data.response = true;
    data.backend_data = resp.data;

    if (action?.data) {
      action.data();
    }

    toast.success(resp?.data?.message);
  } catch (error) {
    if (error?.response?.data?.email) {
      toast.error(`Email : ${error.response.data.email[0]}`);
    } else if (error?.response?.data?.user) {
      toast.error(`User : ${error.response.data.user}`);
    } else {
      toast.error("Invalid User");
    }
  }

  yield put({ type: action_type.GET_NAVIGATE, data });
}
export function* viewMyTeamData(payload) {
  let slug = payload.payload;

  let data = { response: false, backend_data: null };
  yield put({ type: action_type.SET_LOADING, payload: true });

  yield axios
    .get(
      API_URL + `resources/resources-profile/${slug}/?my_team=true`,
      AUTH_HEADERS()
    )
    .then((resp) => {
      data.response = true;
      data.backend_data = resp.data;
    })
    .catch((error) => {
      toast.error("Error");
    });

  yield put({ type: action_type.SET_LOADING, payload: false });
  yield put({ type: action_type.SET_MY_TEAM_USER_DETAILS, data });
}

// export function* getPostContract(payload) {
//   let data = { response: false, backend_data: null };
//   let formValue = payload?.payload;
//   const urlOld = API_URL + "settings/analyze-contract/"; // previous;
//   // const urlNew = API_URL + "ai/analyze-contract/"; //new
//   const urlNew = API_URL + "/ai/analyze-contract/v2/"; //new include the Reading of 100 page or larger contract
//   yield axios
//     .post(urlNew, formValue, AUTH_MULTYPART_HEADERS())
//     .then((resp) => {
//       data.response = true;
//       data.backend_data = resp.data;

//       if (payload?.data) {
//         payload?.data();
//       }

//       toast.success(resp?.data?.message);
//     })
//     .catch((error) => {
//       toast.error(`Unreadable - Contact Error`);
//       if (payload?.data) {
//         payload?.data();
//       }
//     });

//   yield put({ type: action_type.GET_NAVIGATE, data });
//   yield put({ type: action_type.SET_ANALYZE_CONTRACT, data });
// }

export function* getPostContract(payload) {
  let data = { response: false, backend_data: null };
  let formValue = payload?.payload;
  const urlNew = API_URL + "/ai/analyze-contract/v2/";

  // Setup delay toast after 40 seconds
  let delayToastShown = false;
  const delayToastTimeout = setTimeout(() => {
    toast.info(
      "Please wait, your contract is large. It may take a few more seconds to analyze."
    );
    delayToastShown = true;
  }, 30000); // 40 seconds

  try {
    const resp = yield call(() =>
      axios.post(urlNew, formValue, AUTH_MULTYPART_HEADERS())
    );

    clearTimeout(delayToastTimeout); // clear delay toast if request completes early

    data.response = true;
    data.backend_data = resp.data;

    if (payload?.data) {
      payload.data();
    }

    toast.success(resp?.data?.message);
  } catch (error) {
    clearTimeout(delayToastTimeout); // ensure timeout is cleared on error

    toast.error("Unreadable - Contract Error");

    if (payload?.data) {
      payload.data();
    }
  }

  yield put({ type: action_type.GET_NAVIGATE, data });
  yield put({ type: action_type.SET_ANALYZE_CONTRACT, data });
}

export function* getAnalyzeByAI(payload) {
  let data = { response: false, backend_data: null };
  let formValue = payload?.payload;

  yield axios
    .post(
      API_URL + "settings/openai/analyze-contract/",
      formValue,
      AUTH_HEADERS()
    )
    .then((resp) => {
      data.response = true;
      data.backend_data = resp.data;

      if (payload?.data) {
        payload?.data();
      }
      payload.callback(resp.data);
      // toast.success(resp?.data?.message);
    })
    .catch((error) => {
      payload.callback(error);
      toast.error(`Unreadable - Contact Error`);
      if (payload?.data) {
        payload?.data();
      }
    });

  yield put({ type: action_type.GET_NAVIGATE, data });
  yield put({ type: action_type.SET_ANALYZE_BY_AI, data });
}

export function* getUserResetPassword(payload) {
  let data = { response: false, backend_data: null };
  let formValue = payload?.payload;

  yield axios
    .post(
      API_URL + "accounts/password-reset/",
      formValue,
      AUTH_MULTYPART_HEADERS()
    )
    .then((resp) => {
      data.response = true;
      data.backend_data = resp.data;

      if (payload?.data) {
        payload?.data();
      }

      toast.success(resp?.data?.message);
    })
    .catch((error) => {
      if (error?.response?.data?.email) {
        toast.error(`${"Email"} : ${error?.response?.data?.email[0]}`);
      }

      if (error?.response?.data?.user) {
        toast.error(`${"User"} : ${error?.response?.data?.user}`);
      }
    });

  yield put({ type: action_type.GET_NAVIGATE, data });
}

export function* getResourceReserveRequest(payload) {
  let data = { response: false, backend_data: null };
  let formValue = payload?.payload;

  yield axios
    .post(API_URL + "common/request-reserve/", formValue, AUTH_HEADERS())
    .then((resp) => {
      data.response = true;
      data.backend_data = resp.data;

      if (payload?.data) {
        payload?.data();
      }

      toast.success("Email Send Successfully");
    })
    .catch((error) => {
      toast.error("Error");
    });

  yield put({ type: action_type.GET_NAVIGATE, data });
}

export function* getResourceAcceptReserveRequest(payload) {
  let data = { response: false, backend_data: null };
  let formValue = payload?.payload;

  yield axios
    .get(
      API_URL +
        `resources/accept-request/?user_id=${formValue?.user_id}&resource_id=${formValue?.resource_id}`,
      AUTH_HEADERS()
    )
    .then((resp) => {
      data.response = true;
      data.backend_data = resp.data;

      if (payload?.data) {
        payload?.data();
      }

      toast.success(resp?.data?.message);
    })
    .catch((error) => {
      // if (error) {
      //   toast.error('Error');
      // }
    });

  yield put({ type: action_type.GET_NAVIGATE, data });
}
